module.exports = __webpack_public_path__ + "img/erro.f9c6d6a9.svg";